export default function Logo({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox={`0 0 48 48`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#AFBD77" />
      <rect width="48" height="48" rx="24" fill="black" fillOpacity="0.6" />
      <path
        d="M33.8055 22.0415H33V22H24V26H29.6515C28.827 28.3285 26.6115 30 24 30C20.6865 30 18 27.3135 18 24C18 20.6865 20.6865 18 24 18C25.5295 18 26.921 18.577 27.9805 19.5195L30.809 16.691C29.023 15.0265 26.634 14 24 14C18.4775 14 14 18.4775 14 24C14 29.5225 18.4775 34 24 34C29.5225 34 34 29.5225 34 24C34 23.3295 33.931 22.675 33.8055 22.0415Z"
        fill="white"
      />
      <path
        d="M15.1523 19.3455L18.4378 21.755C19.3268 19.554 21.4798 18 23.9993 18C25.5288 18 26.9203 18.577 27.9798 19.5195L30.8083 16.691C29.0223 15.0265 26.6333 14 23.9993 14C20.1583 14 16.8273 16.1685 15.1523 19.3455Z"
        fill="white"
      />
      <path
        d="M23.9994 34.0003C26.5824 34.0003 28.9294 33.0118 30.7039 31.4043L27.6089 28.7853C26.5712 29.5745 25.3032 30.0014 23.9994 30.0003C21.3984 30.0003 19.1899 28.3418 18.3579 26.0273L15.0969 28.5398C16.7519 31.7783 20.1129 34.0003 23.9994 34.0003Z"
        fill="white"
      />
      <path
        d="M33.8055 22.0415H33V22H24V26H29.6515C29.2571 27.1082 28.5467 28.0766 27.608 28.7855L27.6095 28.7845L30.7045 31.4035C30.4855 31.6025 34 29 34 24C34 23.3295 33.931 22.675 33.8055 22.0415Z"
        fill="white"
      />
    </svg>
  );
}
